import { ThemeService } from './../../shared/services/theme.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { ClientsService } from '../../shared/services/clients.service';
import { Component, OnInit } from '@angular/core';
import { SitesService } from '../../shared/services/sites.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {
    public filtro: string = '';
    public allClients: any[] = []; // armazenar a lista original
    public clients: any[];

    constructor(private authenticationService: AuthenticationService, private spinner: NgxSpinnerService, private clientsService: ClientsService, private themeService : ThemeService) { }

    ngOnInit() {
        this.themeService.setDefaultTheme();

        let user = this.authenticationService.getCurrentUser();
        if (user.role == 'ECOGEN_ADMINISTRATOR') {
            this.spinner.show();
            this.clientsService.listAll().subscribe(response => {
                this.allClients = this.filterActive(response);
                this.clients = this.allClients;
                
                this.spinner.hide();
            });
        } else {
            this.spinner.show();
            this.clientsService.listAllForUser().subscribe(response => {
                this.allClients = this.filterActive(response);
                this.clients = this.allClients;
                this.spinner.hide();
            });
        }
    }

    applyFilter() {
        const termo = this.filtro.toLowerCase();
        this.clients = this.allClients
            .map(client => {
            const nomeCorresponde = client.name.toLowerCase().includes(termo);
            const sitesFiltrados = client.sites.filter(site =>
                site.name.toLowerCase().includes(termo)
            );

            if (nomeCorresponde || sitesFiltrados.length > 0) {
                return {
                ...client,
                sites: nomeCorresponde ? client.sites : sitesFiltrados // se for o nome do client, mantém tudo; senão, filtra sites
                };
            }

            return null; // não entra no resultado
            })
            .filter(client => client !== null); // remove os que não deram match
    }
    
    filterActive(clients) {
        var results = [];
        for (var clientIdx in clients) {
            if (!clients[clientIdx].active) {
                continue;
            }
            var activeSites = [];
            for (var siteIdx in clients[clientIdx].sites) {
                if (!clients[clientIdx].sites[siteIdx].active) {
                    continue;
                }
                activeSites.push(clients[clientIdx].sites[siteIdx]);
            }
            if (activeSites.length > 0) {
                clients[clientIdx].sites = activeSites;
                results.push(clients[clientIdx]);
            }
        }
        return results;
    }
}
